import React, { useState } from 'react';
import {
  HelpText,
  Combobox,
  Label,
  ValidationMessage
} from '@gjensidige/builders-components';

import styles from '../../style.module.scss';
import { InputTextBoxProps } from '../../Types';

interface AutocompleteOption {
  label: string;
  value: string;
}

interface InputComboBoxProps extends InputTextBoxProps {
  options?: AutocompleteOption[];
  isLoading?: boolean;
  onSearchChange?: (query: string) => void;
}

export const InputComboBox: React.FC<InputComboBoxProps> = ({
  inputProps,
  options = [],
  isLoading = false,
  onSearchChange
}: InputComboBoxProps) => {
  const {
    id,
    labelText,
    name,
    onChange,
    onBlur,
    value,
    placeholder,
    className,
    labelClassName,
    invalid,
    errorText,
    helpText,
    helpTextToggleLabel,
    helpTextCloseLabel,
    isHelpTextAlwaysVisible,
    inputMode,
    prefixImage,
    inputHelpTextId,
    moreInfoModal,
    autoCompleteLabel,
    ref
  } = inputProps;

  const [isToggled, setIsToggled] = useState(false);

  return (
    <>
      {labelText && (
        <Label htmlFor={id || ''} className={labelClassName}>
          {labelText}
        </Label>
      )}
      {helpText && (
        <HelpText
          open={isHelpTextAlwaysVisible || isToggled}
          onToggle={() => setIsToggled(!isToggled)}
          toggle={
            isHelpTextAlwaysVisible
              ? ''
              : (isToggled ? helpTextCloseLabel : helpTextToggleLabel) ||
              labelText ||
              ''
          }
          htmlFor={id || ''}
        >
          {helpText}
        </HelpText>
      )}
      <Combobox
        id={id || ''}
        ref={ref}
        name={name || ''}
        onInput={(event) => {
          const inputValue = event.currentTarget.value;
          if (onSearchChange) {
            onSearchChange(inputValue);
          }
        }}
        onChange={onChange}
        onBlur={onBlur}
        values={value}
        options={options}
        placeholder={placeholder}
        className={`${className || ''}`}
        wrapperProps={{
          className: `${styles.inputWrapperClassAutocompleteAddress}`
        }}
        invalid={invalid}
        inputMode={inputMode}
        prefix={prefixImage}
        filter="custom"
        busy={isLoading}
        aria-describedby={`${inputHelpTextId || ''} ${moreInfoModal?.ariaDescribedBy || ''
          }`}
        {...(autoCompleteLabel ? { autoComplete: autoCompleteLabel } : {})}
      />
      {invalid && errorText && (
        <ValidationMessage htmlFor={id || ''}>{errorText}</ValidationMessage>
      )}
    </>
  );
};
